export function fluidEmbed() {
  // List of Video Vendors embeds you want to support
  const players = ['.embed iframe'];

  // Select videos
  const fluidEmbeds = document.querySelectorAll(players.join(","));

  // If there are videos on the page...
  if (fluidEmbeds.length) {
    // Loop through videos
    for (var i = 0; i < fluidEmbeds.length; i++) {
      // Get Video Information
      const el = fluidEmbeds[i];
      if (el.matches('[src*="embed.music.apple.com"]') || el.matches('[src*="embed.podcasts.apple.com"]')) {
        el.outerHTML = `<div class="embed-apple-music">${el.outerHTML}</div>`;
      } else if (el.matches('[src*="docs.google.com/forms"]')) {
        el.outerHTML = `<div class="embed-google-forms common-border-color">${el.outerHTML}</div>`;
      } else {

        const width = el.getAttribute("width");
        const height = el.getAttribute("height");
        const widthValue = parseFloat(width);
        const heightValue = parseFloat(height);

        if(width && height && !width.includes('%') && !height.includes('%') && widthValue > 0 && heightValue > 0) {
          const parentDiv = el.parentNode;

          // Wrap it in a DIV
          const div = document.createElement("div");
          div.className = "fluid-embed-wrapper";
          // 縦幅を80vhで頭打ちにする際、比率に応じて横幅の上限を算出するため寸法を渡す
          div.style.setProperty("--embed-w", widthValue);
          div.style.setProperty("--embed-h", heightValue);
          div.style.setProperty("--embed-max-width", 80 * widthValue / heightValue + "vh");
          div.style.setProperty("--embed-ratio-padding", heightValue / widthValue * 100 + "%");
          parentDiv.insertBefore(div, el);
          el.remove();
          div.appendChild(el);

          // Clear height/width from fluidEmbed
          el.removeAttribute("height");
          el.removeAttribute("width");
        }
      }
    }
  }
}
